import Base from "./Base";
import {TOOL_SPLIT} from "./ToolType";
import MapCommon from "../../common/MapCommon";
import DrawLineTool from "./DrawLineTool";
import SelectPolygon from "./SelectPolygon";
import * as turf from '@turf/turf'
import mapboxgl from "mapbox-gl";

export default class SplitTool extends Base{
  constructor(options = {}) {
    let params={
      map:null,//地图实例
      showIcon: true,//是否展示图标
      iconCLassName: "iconfont-map map-icon-fenge",//图标类名
      callBackName: "",//正常地图事件回调
      errorEventName: "",//错误地图事件回调
      chineseName: "分割",//中文工具名称
      checkValid:false,//是否检测自相交
      showArea:false,//是否实时展示面积
      callBack:null,
      errorCallBack:null,
      clickLayers:[],//点选目标图层id
      features:[],//需要展示到点选图层的要素
      clickLayersFilters:[],//点击图层过滤器
      stopLayers:[],//遮挡图层id
    }
    Object.assign(params,options)
    super(params.map, TOOL_SPLIT, params);
    this.showArea=params.showArea;
    this.checkValid=params.checkValid;
    this.clickLayersFilters=params.clickLayersFilters;
    this.stopLayers=params.stopLayers;
    this.params=params;

  }

  start(){
    super.start();
    this.tempLayerId=""
    if(this.params.features&&this.params.features.length>0){//已有多边形，直接绘制然后分割
      this._startDrawLine();
      this.curPolygon=this.params.features[0];
      this.tempLayerId=MapCommon.addHighLightPolygon(this.map,this.curPolygon)

    }else {
      this._startSelectPolygon();
    }

  }
  _startSelectPolygon(){
    //需要点选的情况，增加点选图层
    this.selectControl=new SelectPolygon({
      map:this.map,
      continueSelect:false,
      clickLayers:this.params.clickLayers,
      showIcon:false,
      clickLayersFilters:this.params.clickLayersFilters,//点击图层过滤器
      stopLayers:this.params.stopLayers,//遮挡图层id
      callBack:(res)=>{
        console.log(res)//绘制成功回调
        this.selectControl.close();
        this.selectControl=null;
        this.curPolygon=res.features[0];
        this.tempLayerId=MapCommon.addHighLightPolygon(this.map,res);
        this._startDrawLine();
      }
    });
    this.selectControl.start();
  }


  _startDrawLine(){
     this.drawLineControl=new DrawLineTool({
       map:this.map,
       showIcon:false,
       innerUse:true,
       isBrokenLine: false,
       callBack:(e)=>{
         console.log("绘制完成",e)
         this.drawLineControl.close();
         this.drawLineControl=null;
         this._split(e);
       },
       moveCallBack:(e)=>{
         if(this.params.showArea){
           this._splitOverView(e);
         }
       },
     })
    this.drawLineControl.start();
  }
  _split(line){
    let res=MapCommon.splitPolygon(this.curPolygon,line);
    this.finish(res);
  }
  _splitOverView(line){
    let res=MapCommon.splitPolygon(this.curPolygon,line);
    if(this.popups&&this.popups.length>0){
      for (let i = 0; i <this.popups.length ; i++) {
        this.popups[i].remove()
      }
    }
    this.popups=[];
    if(!res.msg){
      for (let i = 0; i < res.features.length; i++) {
        let feature=res.features[i];
        let centerFeature=turf.center(feature);
        let area=turf.area(feature);
        let popup = new mapboxgl.Popup({
          closeButton: false,
          closeOnClick:false,
          className:this.popupClassName
        });
        popup.setLngLat(centerFeature.geometry.coordinates)
          .setText((area * 0.0015).toFixed(2) + "亩")
          .addTo(this.map);

        this.popups.push(popup);
      }
    }
  }


  close(notClearMap=false) {
    this.clear(notClearMap);
    this.clearEvent();
  }

  clear(notClearMap=false) {
    //移除线绘制
    if(this.drawLineControl){
      this.drawLineControl.close();
      this.drawLineControl=null;
    }
    if(this.selectControl){
      this.selectControl.close();
      this.selectControl=null;
    }

    this.clearMap(notClearMap);
  }

  clearMap(notClearMap=false) {
    //不清除地图选择绘制图层
    if(!notClearMap){
      super.clearMap();
    }
    if(this.tempLayerId){
      MapCommon.removeLayerAndSource(this.map,this.tempLayerId)
    }
  }

  clearEvent() {
    super.clearEvent();
    this.clickLayers=[];
  }
}



// WEBPACK FOOTER //
// ./src/tool/edit/SplitTool.js